import { PatientTreatmentQueueListItemModel } from 'src/app/api/proxy/practice/models/patient-treatment-queue-list-item-model';
import { PatientTreatmentQueueModel } from 'src/app/api/proxy/practice/models/patient-treatment-queue-model';
import { TreatmentQueueStatusType } from 'src/app/api/proxy/practice/models/treatment-queue-status-type';

export function isActiveQueuedVisitStatus(status?: TreatmentQueueStatusType): boolean {
  return (
    status === TreatmentQueueStatusType.Queued ||
    status === TreatmentQueueStatusType.InProgress
  );
}

export function queuedVisitByEncounterId(
  queues: PatientTreatmentQueueListItemModel[],
): Map<string, PatientTreatmentQueueListItemModel> {
  const byEncounter = new Map<string, PatientTreatmentQueueListItemModel>();
  for (const queue of queues) {
    if (queue.encounterId && isActiveQueuedVisitStatus(queue.status)) {
      byEncounter.set(queue.encounterId, queue);
    }
  }
  return byEncounter;
}

/** False when Adjust should resume encounter/cache state instead of a fresh queue snapshot. */
export function shouldTreatAsFreshQueuedLoad(options: {
  pendingRecallEncounterId?: string | null;
  queuedPartsHydrated?: boolean;
  wasOpenedInAdjust?: boolean;
}): boolean {
  if (options.pendingRecallEncounterId || options.queuedPartsHydrated) {
    return false;
  }
  return !options.wasOpenedInAdjust;
}

export function activeUnlinkedQueuedVisits(
  queues: PatientTreatmentQueueListItemModel[],
): PatientTreatmentQueueListItemModel[] {
  return queues.filter(
    (queue) => !queue.encounterId && !!queue.id && isActiveQueuedVisitStatus(queue.status),
  );
}

/** Load a queue, mark it InProgress, and return it for Adjust hydrate/nav state. */
export async function startQueuedSession(options: {
  loadQueue: () => Promise<PatientTreatmentQueueModel | null | undefined>;
  markInProgress: (queuedTreatment: PatientTreatmentQueueModel) => Promise<unknown>;
}): Promise<PatientTreatmentQueueModel | null> {
  let queuedTreatment: PatientTreatmentQueueModel | null | undefined;
  try {
    queuedTreatment = await options.loadQueue();
    if (!queuedTreatment?.id || !queuedTreatment.patientId) {
      return null;
    }
  } catch {
    return null;
  }

  try {
    await options.markInProgress(queuedTreatment);
    return queuedTreatment;
  } catch {
    return null;
  }
}
